import type { SVGProps } from "react";

const SvgKbLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="1 1 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#kbLogo_svg__a)">
      <path d="M24.877.5h-24v12.24h24V.5Z" fill="#E3233D" />
      <path d="M24.877 12.5h-24v12h24v-12Z" fill="#000" />
      <path d="M20.684 11.771H5.07v1.46h15.614v-1.46Z" fill="#fff" />
    </g>
    <defs>
      <clipPath id="kbLogo_svg__a">
        <path fill="#fff" transform="translate(.877 .5)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKbLogo;
